// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"k3-z","dimensionLabel":"l3-z","styleChooserControlWrapper":"m3-z","styleChooserControl":"n3-z","disabled":"o3-z","giftCard":"p3-z","styleChooserText":"q3-z"};